import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--left",
  "use": "icon-arrow--left-usage",
  "viewBox": "0 0 7 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 11\" id=\"icon-arrow--left\"><path d=\"M5.35 10.27c.12.123.272.19.452.19.36 0 .65-.29.65-.66a.686.686 0 0 0-.202-.48L2.428 5.493 6.25 1.681a.696.696 0 0 0 .202-.481.65.65 0 0 0-.65-.66.615.615 0 0 0-.453.19L1.101 4.98a.723.723 0 0 0-.229.52c0 .196.077.364.23.514l4.247 4.256Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol